// AuthModal.jsx
import { useState } from 'react';
import { Dialog, DialogTitle } from '@material-ui/core';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';

const AuthModal = ({ isOpen, onClose, onSuccess }) => {
	const [authMode, setAuthMode] = useState('signUp');

	const handleToggleAuthMode = () => setAuthMode((prevState) => (prevState === 'signIn' ? 'signUp' : 'signIn'));

	return (
		<Dialog open={isOpen} onClose={onClose} fullWidth>
			<DialogTitle>{authMode === 'signIn' ? 'Sign In' : 'Sign Up'}</DialogTitle>

			{authMode === 'signIn' ? (
				<SignInForm handleToggleAuthMode={handleToggleAuthMode} onClose={onClose} onSuccess={onSuccess} />
			) : (
				<SignUpForm handleToggleAuthMode={handleToggleAuthMode} onClose={onClose} onSuccess={onSuccess} />
			)}
		</Dialog>
	);
};

export default AuthModal;
